export const TOP = 'TOP' as const;
export const BOTTOM = 'BOTTOM' as const;
export const OVERSCAN_COUNT = 5;
